class Anniversary10thSceneGallery extends HTMLElement {
  connectedCallback() {
    if (this.isInitialized) return;

    this.wall = this.querySelector('[data-scene-wall]');
    this.shiftColumns = [...this.querySelectorAll('[data-scene-shift]')];
    this.gsap = window.gsap;
    this.ScrollTrigger = window.ScrollTrigger;

    if (!this.wall || !this.shiftColumns.length || !this.gsap || !this.ScrollTrigger) return;

    this.isInitialized = true;
    this.handleWindowLoad = this.handleWindowLoad.bind(this);
    this.gsap.registerPlugin(this.ScrollTrigger);

    this.gsapContext = this.gsap.context(() => {
      this.gsapMatchMedia = this.gsap.matchMedia();
      this.gsapMatchMedia.add('(min-width: 768px) and (prefers-reduced-motion: no-preference)', () =>
        this.setupShift()
      );
    }, this);

    if (document.readyState === 'complete') {
      this.ScrollTrigger.refresh();
    } else {
      window.addEventListener('load', this.handleWindowLoad, { once: true });
    }
  }

  // 设计稿图片墙宽 1278、错落 109,按实际渲染宽度等比换算
  getShiftDistance() {
    return (this.wall.offsetWidth / 1278) * 109;
  }

  setupShift() {
    this.gsap.fromTo(
      this.shiftColumns,
      { y: 0 },
      {
        y: () => this.getShiftDistance(),
        ease: 'none',
        scrollTrigger: {
          trigger: this.wall,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 0.5,
          invalidateOnRefresh: true
        }
      }
    );
  }

  handleWindowLoad() {
    this.ScrollTrigger?.refresh();
  }

  disconnectedCallback() {
    if (!this.isInitialized) return;

    window.removeEventListener('load', this.handleWindowLoad);
    this.gsapMatchMedia?.revert();
    this.gsapContext?.revert();
    this.ScrollTrigger?.refresh();

    this.gsapMatchMedia = null;
    this.gsapContext = null;
    this.isInitialized = false;
  }
}

if (!customElements.get('anniversary-10th-scene-gallery')) {
  customElements.define('anniversary-10th-scene-gallery', Anniversary10thSceneGallery);
}
